module.exports = __webpack_public_path__ + "static/media/quote5.3c3eb4dd.png";